import { render } from "./CollapsibleSection.vue?vue&type=template&id=449fb4b2&ts=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__